<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";
export default {
  name: "baseBar",
  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    rate: {
      type: String,
      default: "",
    },
    datas: {
      type: Array,
      default: [],
    },
  },
  setup(props) {
    // console.log(props);
    const myEcharts = ref(null);
    const chart = new InitChart(props, myEcharts);
    onMounted(() => {
      // console.log(props)
      chart.init(props.datas);
      
    });
    return {
      myEcharts,
    };
  },
};
class InitChart {
  constructor(props, myEcharts) {
    this.props = props;
    this.myEcharts = myEcharts;
    this.state = {
      chart: null,
    };
  }

  init(datas) {
    this.state.chart && this.destory();
    this.state.chart = echarts.init(this.myEcharts.value);

   const yData = datas.map(item => item.name);
  const zData = datas.map(item => item.finished);
  const pData = datas.map(item => item.percent);
  // 设置等长的背景柱状图
  const maxData = new Array(yData.length).fill(100);

    this.state.chart.setOption({
        grid: {
      left: "18%",
      right: "18%",
      bottom: "5%",
      top: "5%",
      containLabel: false
   },
   xAxis: [
      {
         show: true
      },
      {
         show: false,
         splitLine: {
            show: false
         }
      }
   ],
   yAxis: [
      {
         show: true,
         data: yData,
         position: "left",
         axisLabel: {
            lineHeight: 0,
            verticalAlign: "bottom",
            fontSize: 30,
            color: "#ffff",
            formatter: "{value}"
         },
         axisLine: {
            show: false
         },
         splitLine: {
            show: false
         },
         axisTick: {
            show: false
         }
      },
      {
         show: true,
         data: zData,
         offset: 5,
         position: "right",
         axisLabel: {
            lineHeight: 0,
            verticalAlign: "bottom",
            fontSize: 30,
            color: "#00D7E1",
            formatter: "{value}"
         },
         axisLine: {
            show: false
         },
         splitLine: {
            show: false
         },
         axisTick: {
            show: false
         }
      }
   ],
   series: [
      {
         name: "进度",
         show: true,
         type: "bar",
         barGap: "-100%",
         xAxisIndex: 1,
         barWidth: 30,
         itemStyle: {
            borderRadius: 10,
            color: {
               type: 'linear',
               x: 0,
               y: 0,
               x2: 1,
               y2: 0,
               colorStops: [
                  {
                     offset: 0,
                     color: '#03BBFF', // 0% 处的颜色
                  },
                  {
                     offset: 1,
                     color: '#072541', // 0% 处的颜色
                  },
               ],
               global: false, // 缺省为 false
            }
         },
         label: {
            show: false, 
            position: 'insideRight', 
            formatter: '{c}%',
            offset: [-10, 2], 
            color: '#fff'
         },
         labelLine: {
            show: false
         },
         z: 2,
         data: pData,
         animationDelay: 1000,
         animationDuration: 1000
      },
      {
         name: "百分比",
         z: 1,
         show: true,
         type: "bar",
         xAxisIndex: 1,
         barGap: "-100%",
         barWidth: 30,
         itemStyle: {
            borderRadius: 10,
            color: "#1C2E38"
         },
         label: {
            show: false,
         },
         data: maxData
      }
   ]
         
    });
    window.addEventListener("resize", () => {
      this.state.chart.resize();
    });
  }

  destory() {
    this.state.chart.dispose();
    window.removeEventListener("resize", () => {
      console.log("事件移除");
    });
  }
}
</script>
<style lang="less"></style>
